import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-DocDefPrimLib',
  template: `
    <p>
      doc-def-prim-lib works!
    </p>
  `,
    styleUrls: ['./doc-def-prim-lib.component.css']
})
export class DocDefPrimLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
